
const digest = 'e3f923a7a5f05de8a24fda53ddf3bb792608c2a7cf9124902d3b9d2aa28093fc';
const classes = {"wrapper":"_wrapper_vh619_1","contentWrapper":"_contentWrapper_vh619_10","loadingWrapper":"_loadingWrapper_vh619_13","content":"_content_vh619_10"};
const css = `._wrapper_vh619_1 {
  display: flex;
  flex-direction: row;
  font-family: Rubik, "sans-serif";
  flex-grow: 1;
  height: 100%;
  border: 1px solid #eaedf3;
  background-color: #ffffff;
}
._wrapper_vh619_1 ._contentWrapper_vh619_10 {
  flex: 1;
}
._wrapper_vh619_1 ._contentWrapper_vh619_10 ._loadingWrapper_vh619_13 {
  height: 100%;
  padding: 12px;
}
._wrapper_vh619_1 ._contentWrapper_vh619_10 ._content_vh619_10 {
  flex: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  